import { Endpoint } from "@rest-hooks/endpoint";
const fetchStandardText = (data) => fetch(`/api/applications/${data.applicationNumber}/standard-text/${data.code}`).then(res => {
    if (res.ok)
        return res.json();
    return [];
});
const fetchStandardTextByApplicationId = (data) => fetch(`/api/applications/${data.applicationNumber}/standard-text/${data.code}/id`).then(res => {
    if (res.ok)
        return res.json();
    return [];
});
export const StandardTextListEndpoint = new Endpoint(fetchStandardText, {});
export const StandardTextListEndpointByApplicationId = new Endpoint(fetchStandardTextByApplicationId, {});
//# sourceMappingURL=StandardTextListResource.js.map